module.exports = __webpack_public_path__ + "img/am.caf85301.svg";